

const frases = [
  {
    id: "1",
    frase: "Este es tu inicio 💪"
  },
  {
    id: "2",
    frase: "Vamos sí se puede!!",
  },
  {
    id: "3",
    frase: "Te felicito por tu constancia!",
  },
]

export {
  frases,
}